import { useQuery, useQueryClient } from "@tanstack/react-query";
import { TransitPurchaseOrderService } from "src/services";
import { QueryParamsMapper } from "src/mappers/queryParamsMapper";
import { queryKeys } from "src/constants";
import { DateTimeRange, TransitPurchaseOrderPaginationOptions, TransitPurchaseOrdersFilters } from "src/types";

const useTransitPurchaseOrders = (
  transitPurchaseOrderService: TransitPurchaseOrderService,
  dateTimeRange?: DateTimeRange,
  filter?: TransitPurchaseOrdersFilters,
  paginationOptions?: TransitPurchaseOrderPaginationOptions
) => {
  const queryClient = useQueryClient();

  const queryParams = QueryParamsMapper.getTransitPurchaseOrdersQueryParams(dateTimeRange, filter, paginationOptions);

  const {
    data: paginatedTransitPurchaseOrders,
    error: fetchError,
    isLoading
  } = useQuery({
    queryKey: queryKeys.paginatedTransitPurchaseOrders(queryParams),
    queryFn: () => transitPurchaseOrderService.getTransitPurchaseOrders(queryParams)
  });

  const refreshTransitPurchaseOrders = () => {
    queryClient.removeQueries({
      queryKey: queryKeys.paginatedTransitPurchaseOrders(),
      exact: false
    });
  };

  return { paginatedTransitPurchaseOrders, fetchError, isLoading, refreshTransitPurchaseOrders };
};

export { useTransitPurchaseOrders };
